// extracted by mini-css-extract-plugin
export default {"setupProjects":"SetupProjects_setupProjects__cJJtL","projects":"SetupProjects_projects__wpkz1"};